import Element from '../../../core/Element';
import { Align, Color, FontType, Direction } from '../../../core/enums';
import type { ButtonProps, Tools } from '../../../core/types';
import { BackgroundImage } from '../../atoms/background-image';
import { CardArt } from '../../atoms/card-art';
import { Column, Row } from '../../atoms/grid';
import { GroupedButtons } from '../../buttons-and-links/grouped-button';
import styles from './index.module.less';

interface Props {
  data: {
    title: string;
    subtitle: string;
    fee?: {
      header?: string;
      text?: string;
    };
    cardArtUrl: string;
    ctas?: ButtonProps[];
    contentBeforeCTAComponent?:
      | React.ReactElement
      | React.ReactElement[]
      | string;
    contentAfterCTA?: React.ReactNode;
    backgroundImage: string;
    disclaimerLinks: {
      url: string;
      text: string;
      tools?: Tools;
    }[];
  };
  qeId?: string;
}

export const MobileCardDetailHeader = ({
  data: {
    backgroundImage,
    cardArtUrl,
    ctas,
    contentBeforeCTAComponent,
    contentAfterCTA,
    disclaimerLinks,
    fee = {},
    subtitle,
    title,
  },
  qeId = 'MobileCardDetailHeader',
}: Props) => (
  <BackgroundImage imageUrl={backgroundImage} qeId={qeId}>
    <Element
      theme={{
        textAlign: Align.Center,
        padding: 20,
      }}
    >
      <Element
        theme={{
          padding: 20,
        }}
        className={styles.content}
      >
        <Row theme={{ marginBottom: 20 }}>
          <Column $sm="12">
            <Element
              theme={{
                color: Color.Black,
                fontType: FontType.HelveticaRegular,
                textBody: 1,
              }}
            >
              {title}
            </Element>
          </Column>
        </Row>
        <Row theme={{ marginBottom: 20 }} className={styles.centerAlign}>
          <Column $sm="6">
            <CardArt
              theme={{ horizontallyFluid: true }}
              src={cardArtUrl}
              alt={title}
            />
          </Column>
        </Row>
        <Row theme={{ marginBottom: 20 }}>
          <Column $sm="12">
            <Element
              theme={{
                color: Color.DeepBlue,
                fontType: FontType.BentonBold,
                textHeading: 4,
                marginBottom: 10,
              }}
            >
              {subtitle}
            </Element>
          </Column>
          <Column $sm="12" key={title}>
            <>
              <Element Component="span" theme={{ textLegal: 2 }}>
                {fee.header}
              </Element>
              <Element Component="span" theme={{ textLegal: 1 }}>
                {fee.text}
              </Element>
            </>
          </Column>
        </Row>
        {contentBeforeCTAComponent && (
          <Element theme={{ marginTop: 10, marginBottom: 10 }}>
            {contentBeforeCTAComponent}
          </Element>
        )}
        <GroupedButtons
          data={{ ctas, contentAfterCTA, disclaimerLinks }}
          $direction={Direction.Horizontal}
          $isMinMax={false}
          customization={{ evenCtaWidths: true }}
        />
      </Element>
    </Element>
  </BackgroundImage>
);
